export const TRIP_TOTAL_TEXT = "Trip total";
export const UNDER_25_WARNING =
  "This rental car company may charge an underage driver fee at pick-up.";
